import React from 'react';
import LabeledValues from '../../../Elements/LabeledValues';

const values = [
  { label: 'Bill to', value: 'Sam Example', note: 'Example Car Wash', isWide: true },
  { label: 'Purchase order #', value: null },
  { label: 'Currency', value: 'United States Dollars' },
  { label: 'Days to pay', value: 30 },
  { label: 'Late fee %', value: '0.00' },
];

function LabeledValuesDemoComponent() {
  return (
    <div style={{ maxWidth: 460 }}>
      <LabeledValues values={values} />
    </div>
  );
}

export const labeledValuesDemo = {
  id: 'labeled-values',
  title: 'Labeled values',
  category: 'Cards',
  importPath: 'Elements/LabeledValues',
  notes: [
    'Facts read back as small capitals labels over their values, two to a row; on a phone, one.',
    'values are { label, value, note, isWide }: the note is a muted line under the value, and a wide fact takes the whole row.',
    'An empty value shows as a muted "Not set", as on DefinitionCard, whose rows put the label beside the value instead.',
  ],
  snippet: '<LabeledValues\n  values={[{ label: "Bill to", value: contactName, note: clientName, isWide: true }]}\n/>',
  render: LabeledValuesDemoComponent,
};
